import { useMutation } from '@apollo/client'
import React, { useState } from 'react'

import { UPDATE_FLEET_DRIVER } from '../../../Services/cabapi/fleetggl'
import CustomInput from '../../../Components/Input/CustomInput'
import DatePicker from '../../../Components/Input/DatePicker'
import { SkyButton, SkyOutlinedButton } from '../../../Components/Buttons'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

const FleetDriverEdit = ({}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const selectedDriver = location?.state
  const [driverDetails, setDriverDetails] = useState({
    firstName: selectedDriver?.firstName || '',
    middleName: selectedDriver?.middleName || '',
    lastName: selectedDriver?.lastName || '',
    mobileNumber: selectedDriver?.mobileNumber || '',
    email: selectedDriver?.email || '',
    licence: '',
    permanentAddress: selectedDriver?.permanentAddress || '',
    trDate: new Date(selectedDriver?.trDate) || new Date(),
    birthDate: new Date(selectedDriver?.birthDate) || new Date(),
  })

  const [errors, setErrors] = useState({})
  const [updateFleetDriver, { data }] = useMutation(UPDATE_FLEET_DRIVER)
  const handleInputChange = (name, value) => {
    setDriverDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }))
  }
  const validateForm = () => {
    const newErrors = {}
    if (!driverDetails.firstName)
      newErrors.firstName = 'First Name is required*'
    if (!driverDetails.middleName)
      newErrors.middleName = 'Middle Name is required *'
    if (!driverDetails.lastName) newErrors.lastName = 'Last Name is required*'
    if (!driverDetails.mobileNumber)
      newErrors.mobileNumber = 'Mobile Number is required*'
    if (!driverDetails.email) newErrors.email = 'Email is required*'
    if (!driverDetails.permanentAddress)
      newErrors.permanentAddress = 'Permanent Address is required*'
    if (!driverDetails.birthDate) {
      newErrors.birthDate = 'Date of birth is required *'
    } else {
      const today = new Date()
      const birthDate = new Date(driverDetails.birthDate)
      const age = today.getFullYear() - birthDate.getFullYear()
      const month = today.getMonth() - birthDate.getMonth()
      const day = today.getDate() - birthDate.getDate()

      const validAge = age > 18 || (age === 18 && month >= 0 && day >= 0)

      if (!validAge) {
        newErrors.birthDate = 'You must be 18 or older to register *'
      }
    }
    if (!driverDetails.trDate) newErrors.trDate = 'Tr Expiry Date is required*'

    setErrors(newErrors)

    return Object.keys(newErrors).length === 0
  }

  const handleUpdate = async () => {
    if (!validateForm()) return
    const inputData = {
      firstName: driverDetails.firstName,
      middleName: driverDetails.middleName,
      lastName: driverDetails.lastName,
      mobileNumber: driverDetails.mobileNumber,
      email: driverDetails.email,
      permanentAddress: driverDetails.permanentAddress,
      trDate: driverDetails.trDate.toISOString(),
      birthDate: driverDetails.birthDate.toISOString(),
    }

    try {
      await updateFleetDriver({
        variables: {
          fleetDriverId: selectedDriver?._id,
          updateFleetDriverInput: inputData,
        },
      })
        .then((res) => {
          toast.success('Driver Updated Successfully')
          navigate(-1)
          console.log('data', data)
        })
        .catch((error) => {
          console.log('error', error)
        })
    } catch (error) {
      console.log('error', error)
    }
  }

  return (
    <div className="flex justify-center w-full">
      <div className="bg-white w-full shadow-lg p-4 my-4 sm:w-[90%] xl:w-[100%]">
        <div className="flex flex-start">
          <SkyOutlinedButton label={'Back'} onClick={() => navigate(-1)} />
        </div>
        <h2 className="text-xl font-bold text-center">Update Driver</h2>
        <div className="mt-2">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start">
            <div>
              <CustomInput
                placeholderValue={'First Name'}
                labelValue={'First Name'}
                required
                name={`firstname`}
                value={driverDetails.firstName || ''}
                onChange={(value) => handleInputChange('firstName', value)}
                style={{
                  borderColor: errors.firstName ? 'red' : '',
                }}
              />
              {errors.firstName && (
                <small className="text-red-500">{errors.firstName}</small>
              )}
            </div>
            <div>
              <CustomInput
                placeholderValue={'Middle Name'}
                labelValue={'Middle Name'}
                value={driverDetails.middleName || ''}
                onChange={(value) => handleInputChange('middleName', value)}
              />
              {errors.middleName && (
                <small className="text-red-500">{errors.middleName}</small>
              )}
            </div>
            <div>
              <CustomInput
                placeholderValue={'Last Name'}
                labelValue={'Last Name'}
                required
                value={driverDetails?.lastName || ''}
                onChange={(value) => handleInputChange('lastName', value)}
                style={{
                  borderColor: errors.lastName ? 'red' : '',
                }}
              />
              {errors.lastName && (
                <small className="text-red-500">{errors.lastName}</small>
              )}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start">
            <div>
              <CustomInput
                formatMobileNumber={true}
                placeholderValue={'Mobile Number'}
                labelValue={'Mobile Number'}
                inputtype={'tel'}
                value={driverDetails?.mobileNumber || ''}
                onChange={(value) => handleInputChange('mobileNumber', value)}
                style={{
                  borderColor: errors.mobileNumber ? 'red' : '',
                }}
              />
              {errors.mobileNumber && (
                <small className="text-red-500">{errors.mobileNumber}</small>
              )}
            </div>
            <div>
              <CustomInput
                placeholderValue={'Email'}
                labelValue={'Email'}
                value={driverDetails?.email || ''}
                onChange={(value) => handleInputChange('email', value)}
                style={{
                  borderColor: errors.email ? 'red' : '',
                }}
              />
              {errors.email && (
                <small className="text-red-500">{errors.email}</small>
              )}
            </div>
            <div>
              <CustomInput
                placeholderValue={'Permanent Address'}
                labelValue={'Permanent Address'}
                value={driverDetails?.permanentAddress || ''}
                onChange={(value) =>
                  handleInputChange('permanentAddress', value)
                }
                style={{
                  borderColor: errors.permanentAddress ? 'red' : '',
                }}
              />
              {errors.permanentAddress && (
                <small className="text-red-500">
                  {errors.permanentAddress}
                </small>
              )}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start">
            <div>
              <DatePicker
                labelValue="Birth Date"
                selected={driverDetails?.birthDate || new Date()}
                onChange={(value) => handleInputChange('birthDate', value)}
                style={{
                  borderColor: errors.birthDate ? 'red' : '',
                }}
              />
              {errors.birthDate && (
                <small className="text-red-500">{errors.birthDate}</small>
              )}
            </div>
            <div>
              <DatePicker
                labelValue="Tr Expiry Date"
                selected={driverDetails?.trDate || new Date()}
                onChange={(value) => handleInputChange('trDate', value)}
                style={{
                  borderColor: errors.trDate ? 'red' : '',
                }}
                minDate={new Date().toISOString().split('T')[0]}
                maxDate={(() => {
                  const maxDate = new Date()
                  maxDate.setFullYear(maxDate.getFullYear() + 3) // Set maxDate to 1 year from today
                  return maxDate.toISOString().split('T')[0] // Return in YYYY-MM-DD format
                })()}
              />
              {errors.trDate && (
                <small className="text-red-500">{errors.trDate}</small>
              )}
            </div>
          </div>
        </div>

        <div className=" flex gap-4 my-2">
          <SkyButton label={'Submit'} onClick={() => handleUpdate()} />
          <SkyOutlinedButton label={'Cancel'} onClick={() => navigate(-1)} />
        </div>
      </div>
    </div>
  )
}

export default FleetDriverEdit
